import styled from "styled-components";
import {
  inputBorderColor,
  labelColor,
  mediumFont,
  newsecondaryColor,
  whiteColor,
} from "@app/styles";
type Props = {
  disabled?: boolean;
};

export const HeaderRow = styled.div`
  width: 100%;
  min-height: 70px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  background-color: #8bc53f;
  z-index: 10;
  /* position: fixed;
  top: 0;
  left: 0; */
  @media print {
    
    padding: 0 8px;
    box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.25);
  }
`;

export const HamburgerMenu = styled.div`
min-width: 36px;
height: 70px;
display: flex;
justify-content: center;
align-items: center;
margin-right: 8px;
cursor: pointer;
`

export const Title = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 150px;
    display: block;
    @media (max-width: 575px) {
      width: 100px;
    }
  }
`;

export const RightContainer = styled.div`
height: 100%;
flex: 1;
display: flex;
justify-content: flex-end;
align-items: center;
`

export const MenuItemsWrapper = styled.div`
  @media print {
    h4 {
      display: none;
    }
  }
display: flex;
margin-right: 12px;
&.responsive{
  position: absolute;
  top: 70px;
  left: 0;
  width: 100% !important;
  background: ${whiteColor};
  border: solid 1px #ebebeb;
  border-radius: 0 0 10px 10px !important;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px;
  flex-direction: column;
  padding: 1rem 0;
  margin: 0 !important;
  z-index: 99;
}
&.hide{
  display: none;
}
&.show{
  display: flex;
}
`

export const MenuItem = styled.div`
height: 70px;
padding: 0 12px;
display: flex;
align-items: center;
cursor: pointer;
overflow: hidden;
position: relative;
&::after{
  content: '';
  width: 100%;
  height: 2px;
  background-color: ${whiteColor};
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  transition: all 0.3s ease;
}
h4{
  font-size: 16px;
  ${mediumFont};
  color: ${whiteColor};
  transition: all 0.3s ease;
  @media (max-width: 991px) {
    color: ${labelColor};
  }
}
&.responsive{
  height: unset;
  padding: 0.75rem 1.5rem;
}
&:hover{
  /* h4{
    color: ${newsecondaryColor};
  } */
  &::after{
    transform: translateX(0);
  }
}
`

export const UserMenu = styled.div`
  display: flex;
  align-items: center;
  max-width: 300px;
  overflow: hidden;
  /* &:hover{
    h4{
      color: ${newsecondaryColor};
    }
  } */
`;

export const Username = styled.h4`
  flex: 1;
  font-size: 16px;
  ${mediumFont};
  color: ${whiteColor};
  line-height: 1.5;
  margin: 0 8px 0 0;
  transition: all 0.3s ease;
  @media (max-width: 991px) {
    color: ${labelColor};
  }
`;

export const ProfileImage = styled.div`
  height: 40px;
  width: 40px;
  background: #eaf7ff;
  /* border: 1px solid ${whiteColor}; */
  border-radius: 50%;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  &.w-unset {
    width: unset !important;
  }
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
`;

export const ConfirmationContentWrapper = styled.div`
  width: 500px;
  padding: 0 40px;
  @media (max-width: 575px) {
    width: 100%;
    padding: 0 24px;
  }
`;

export const ConfirmationContent = styled.p`
  line-height: 1.5;
  margin: 0 0 16px;
  @media (max-width: 575px) {
    font-size: 16px;
  }
`;

export const DialogFooter = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 2px solid ${inputBorderColor};
  padding: 0 64px;
  box-sizing: border-box;
  &.with-no-border {
    border: none;
  }
  &.alt-padding {
    padding: 0 48px;
  }
  &.alt-height {
    height: 72px;
  }
  @media (max-width: 575px) {
    padding: 0 24px !important;
  }
`;

export const CustomToggleWrapper = styled.div`
display: flex;
align-items: center;
& > svg{
  margin-left: 8px;
  cursor: pointer;
}
`